import { render, staticRenderFns } from "./hqglLogisticsInboundDetail.vue?vue&type=template&id=62004f87&scoped=true&"
import script from "./hqglLogisticsInboundDetail.vue?vue&type=script&lang=js&"
export * from "./hqglLogisticsInboundDetail.vue?vue&type=script&lang=js&"
import style0 from "./hqglLogisticsInboundDetail.vue?vue&type=style&index=0&id=62004f87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62004f87",
  null
  
)

export default component.exports